import { CircularProgress } from "@bb-ui/react-library/dist/components/Progress";
import * as React from "react";
import { useTranslation } from "react-i18next";

import { ErrorKey } from "../../domain/error-messages";

export type FailedStateProps = {
  errorKey?: ErrorKey;
};

export const FailedState: React.FC<FailedStateProps> = () => {
  const { t } = useTranslation();

  return (
    <div className="full-screen-wrapper" aria-live="polite" role="status">
      <CircularProgress
        id="doc-viewer-loading"
        error
        size="large"
        variant="indeterminate"
        value={100}
        label={t(`messages.failed`)}
      />
    </div>
  );
};
